
import QueryString from 'query-string'
import { Component, Vue } from 'vue-property-decorator'
import { NewsService } from '@/services/index'
import { ICommentData } from '@/types/news-types'

@Component({
    name: 'Comments',
    components: {
    }
})
export default class extends Vue {
    private news = {}
    private platform = {}
    private comments: any = []
    private pageIndex: number = 1
    private pageSize: number = 50
    private pageTotal: number = 0

    private mounted() {
        this.getComments()
    }

    // 获取父级的评论
    private async getComments() {
        const newsId = this.$route.params.id
        const parsed: any = QueryString.parse(location.search)
        const platformId = parsed.platformId
        const params = { 
            news_id: parseInt(newsId), 
            platform_id: platformId, 
            page_index: this.pageIndex, 
            page_size: this.pageSize,
            media_type: this.$route.query.mtype || 'media'
        }
        const result = await NewsService.getRootComments(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.news = result.data.news
            this.platform = result.data.platform
            this.comments = this.filterComments(result.data.comments)
        }
    }

    // 获取子评论
    private async getChildComments(rootComment: ICommentData) {
        const newsId = this.$route.params.id
        const parsed: any = QueryString.parse(location.search)
        const platformId = parsed.platformId
        const params = { 
            news_id: parseInt(newsId), 
            platform_id: platformId,
            comment_id: rootComment.id,
            page_index: rootComment.pageIndex, 
            page_size: this.pageSize,
            media_type: this.$route.query.mtype || 'media'
        }
        const result = await NewsService.getChildComments(params)
        if (result.status === 200) {
            return result.data
        }
    }

    private filterComments(comments: ICommentData[]) {
        const result = comments.map((comment: ICommentData) => {
            comment = Object.assign(comment, { 
                child_comments: [], 
                isExpand: false,
                pageIndex: 1
            })
            return comment
        })
        return result
    }

    // 展开回复信息
    private async onExpandReply(rootComment: ICommentData, isExpand: boolean) {
        let childComments: ICommentData[] = []
        let childCommentsResult: any = {}
        if (!isExpand) {
            childCommentsResult = await this.getChildComments(rootComment)
            childComments = childCommentsResult.comments
        }
        
        this.comments = this.comments.map((comment: ICommentData) => {
            if (comment.id === rootComment.id) {
                comment.isExpand = !comment.isExpand
                comment.child_comments = childComments
                comment.isMore = childCommentsResult.page_total === this.pageSize ? 
                    true : false
            }
            return comment
        })
    }

    // 获取更多回复
    private async onLoadMoreReply(rootComment: any) {
        rootComment.pageIndex = rootComment.pageIndex + 1
        const childCommentsResult = await this.getChildComments(rootComment)
        const childComments = childCommentsResult.comments
        this.comments = this.comments.map((comment: ICommentData) => {
            if (comment.id === rootComment.id) {
                comment.child_comments = [...comment.child_comments, ...childComments]
                comment.isMore = childCommentsResult.page_total === this.pageSize ? 
                    true : false
            }
            return comment
        })
    }

    private onCurrentChange(page: any) {
        const $backtop = this.$refs.backtop as any
        this.pageIndex = page
        this.getComments()
        $backtop.scrollToTop()
    }
}
